/**
 * 登录相关接口
 */
import { imagePost, get, postJson } from "./axios";
import { imagePost as cpdImagePost } from "./cpdAxios";


/**
 * 登录
 * @param {*} params
 * @returns
 */
export const loginInto = (params) => cpdImagePost(`/login/platform`, params);

export const getLoginData = (params) => get(`/common/current`, params);

// 获取token
// export const getToken = () =>
//   get(`/api/yeion-dataease/api/getLoginInfo4DataEase`);

export const getToken = () => get(`/yeion-dataease/api/getLoginInfo4DataEase`);
/**
 * 退出登录
 * @returns
 */
export const loginOut = () => postJson(`/common/logout`, {});